import type { UserDTO } from "@/domain/dto/user.dto";
// import type { UserEntity } from "@/domain/entities/user.entity";

process.env.NODE_TLS_REJECT_UNAUTHORIZED = "1"; // ⚠️ Solo usar en desarrollo para evitar errores SSL

const apiUrl = process.env.NEXT_PUBLIC_API_URL || "https://localhost:7061";
export const API_ENDPOINT = `${apiUrl}/api/v1.0/security/users`;
export const CREATE_USER_API_ENDPOINT = `${apiUrl}/api/v1.0/business/create`;

export const fetchUsers = async (): Promise<UserDTO[]> => {
    try {
        const response = await fetch(API_ENDPOINT, {
            cache: "no-store", // ⚡ Evita caché para siempre obtener datos frescos
            next: { revalidate: 0 }, // 🔄 Opcional: controla la revalidación en Next.js
        });

        if (!response.ok) {
            throw new Error(`Error fetching users: ${response.statusText}`);
        }

        const data: UserDTO[] = await response.json();
        return data;
    } catch (error) {
        console.error("Fetch error:", error);
        return [];
    }
};

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const createUser = async (userData: any) => {
    const response = await fetch(CREATE_USER_API_ENDPOINT, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
    });

    // console.log(JSON.stringify(userData));

    if (!response.ok) {
        const errorResponse = await response.json();
        const errorMessage = errorResponse.message || "Error desconocido";

        // Lanza un error para que sea gestionado en el componente
        throw new Error(errorMessage);
    }

    // Retorna los datos si la creación fue exitosa
    return await response.json();
};
